import { render, staticRenderFns } from "./governor_mailbox.vue?vue&type=template&id=1cff0971&"
import script from "./governor_mailbox.vue?vue&type=script&lang=js&"
export * from "./governor_mailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports